/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from "react";
import CardError from "../../../components/feedBacks/CardError";
import Loader from "../../../components/feedBacks/loader";
import { useFetchData } from "../../../customHooks/useGetDashboardData";
import { IUser } from "../../../utils/interfaces";
import { useParams } from "react-router-dom";
import LoginTrendChart from "../../../components/Charts/LoginTrends";
import WebsiteVisitChart from "../../../components/Charts/PageVistiChart";
import { formatDateForDisplay } from "../../../utils/formatters";
import BackButton from "../../../components/feedBacks/BackButton";

function UserAnalyticsDetailPage() {
  const { user_id, id } = useParams();
  const {
    data: userDetails,
    isLoading: isUserDetailsLoading,
    error: userDetailsError,
  } = useFetchData<any, IUser>(
    ["/users", "fetchUserDetails", user_id],
    `/users/${user_id}`,
    {},
    // @ts-ignore
    {}
  );

  const transformedData = useMemo(() => {
    if (!userDetails) return [];
    return [
      {
        key: "Email",
        value: userDetails.email,
      },
      {
        key: "Role",
        value: userDetails.access_level || "N/A",
      },
      {
        key: "Last Login",
        value: formatDateForDisplay(userDetails.last_login) || "N/A",
      },
    ];
  }, [userDetails]);
  return (
    <div className=" w-full p-10 !bg-[#f5f5f5] !h-full min-h-[70vh] rounded-xl">
      <div className="flex w-full">
        <div className="flex gap-2 self-start justify-start items-center">
          <BackButton
            showBackText={false}
            link={`/dashboard/admin/user-analytics/${id}`}
          />
        </div>
      </div>
      <div className="flex flex-col gap-10 items-start !justify-start w-full">
        <div className="w-full flex  flex-col gap-10 mt-10">
          {isUserDetailsLoading ? (
            <div className="flex justify-center items-center h-full w-full">
              <Loader />
            </div>
          ) : userDetailsError ? (
            <CardError message="Error fetching user details" />
          ) : (
            <div className="flex flex-col gap-4">
              <h2 className="text-2xl font-semibold">{`${userDetails.first_name} ${userDetails.last_name}`}</h2>
              <div className="grid gap-10 grid-cols-[repeat(auto-fill,minmax(220px,1fr))] w-full ">
                {transformedData.map((stat, index) => (
                  <div
                    key={index}
                    className="bg-white shadow-md flex flex-col items-start justify-center p-6 w-full h-[130px] 
        rounded-2xl break-all"
                  >
                    <span className="font-semibold text-lg">{stat.key}</span>
                    <span>{stat.value}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="w-full mt-6">
          <LoginTrendChart user_id={user_id || ""} />
        </div>
        <div className="w-full mt-6">
          <WebsiteVisitChart user_id={user_id || ""} />
        </div>
      </div>
    </div>
  );
}

export default UserAnalyticsDetailPage;
